export const API_USER_SIGN_UP = 'user/sign-up';
export const API_USER_SIGN_IN = 'user/sign-in';
export const API_USER_FORGOT_PASSWORD = 'user/forgot-password';
export const API_APP_TEMPLATE = '/user/app/:appId/template';

export const API_REDEMPTION_DETAILS = '/redemption/:rid';
export const API_REDEMPTION_APPROVE = `${API_REDEMPTION_DETAILS}/approve`;
export const API_REDEMPTION_REJECT = `${API_REDEMPTION_DETAILS}/reject`;

export const API_USER_UPDATE_PROFILE = 'game/profile';
export const API_USER_UPDATE_PASSWORD = `${API_USER_UPDATE_PROFILE}/change-password`;
export const API_USER_CHECK_RESET_PASSWORD = 'user/check-reset-password';
export const API_USER_RESET_PASSWORD = 'user/reset-password';

export const IMAGE_UPLOAD = 'game/upload/image';
export const API_ABLY_AUTH = 'game/pubsub/auth';

export const API_APP_DETAILS = 'game/app/:appId';

export const API_USER_COINS = `${API_APP_DETAILS}/profile/coins`;
export const API_USER_PROFILE = `${API_APP_DETAILS}/profile/general`;
export const API_USER_TREASURES = `${API_APP_DETAILS}/profile/treasures`;
export const API_USER_DEFINITIONS = `${API_APP_DETAILS}/profile/definitions`;
export const API_LEADERBOARD = `${API_APP_DETAILS}/leaderboard`;
export const API_TREASURES = `${API_APP_DETAILS}/treasures`;
export const API_GAME_INSTANCES = `${API_APP_DETAILS}/instances`;

export const API_GAME = `${API_GAME_INSTANCES}/:gameId`;
export const GAME_MOBILE_BRANCHIO_LINK = `${API_GAME}/generate-app-link`;

export const API_PLAYER_JOIN_GAME = `${API_GAME}/join`;
export const API_PLAYER_READY = `${API_GAME}/ready`;
export const API_PLAYER_ANSWER = `${API_GAME}/answer`;
export const API_PLAYER_LEAVE = `${API_GAME}/leave`;
export const API_PLAYER_SEND_GIFT = `${API_GAME}/gifts/:giftId/make`;
export const API_PLAYER_KICK = `${API_GAME}/kick/:playerId`;
export const API_GAME_TEAM_DEFINITION = `${API_GAME}/definitions`;

export const API_TREASURE_DETAILS = '/game/treasures/:treasureId';
export const API_TREASURE_REDEEM = `${API_TREASURE_DETAILS}/redeem`;

export const API_PAYMENT_PACKS = `${API_APP_DETAILS}/payment/packs`;
